/* Tyre Dispatch tool cards.
   Every block is defensive: it selects its own scene class and returns if
   the card is not on the page, so this file is safe to load anywhere.
   The id namespacing at the top of each SUV-bearing block is load-bearing --
   see the note there before removing it. */

/* ---------- Speed and load lookups: the list steps, the instrument follows ---------- */
(function(){
  var SPD = [["N",140],["P",150],["Q",160],["R",170],["S",180],
             ["T",190],["H",210],["V",240],["W",270],["Y",300]];
  var LOAD = [[82,475],[88,560],[91,615],[94,670],[97,730],
              [100,800],[104,900],[109,1030],[112,1120],[116,1250]];
  [].forEach.call(document.querySelectorAll(".td-lu"), function(sc){
    var spd = sc.classList.contains("td-lu--spd");
    var rows = spd ? SPD : LOAD;
    var items = sc.querySelectorAll(".td-lu-i"),
        val = sc.querySelector(".td-lu-v"),
        needle = sc.querySelector(".td-lu-needle");
    if(!items.length || !val) return;
    var k = spd ? 7 : 3;
    function paint(){
      for(var i=0;i<items.length;i++) items[i].classList.toggle("on", i===k);
      val.textContent = rows[k][1];
      if(needle){
        /* the dial reads 100 to 320 km/h across 240 degrees of sweep */
        var f = Math.max(0, Math.min(1, (rows[k][1]-100)/220));
        needle.style.transform = "rotate(" + (-120 + f*240) + "deg)";
      }
    }
    paint();
    setInterval(function(){ k = (k+1) % rows.length; paint(); }, 1500);
  });
})();

/* ---------- WOF axle check: one axle at a time ---------- */
(function(){
  var STEPS = [
    {slots:["","","",""],       say:0},
    {slots:["ok","ok","no","no"], say:1},
    {slots:["no","no","no","no"], say:2},
    {slots:["ok","ok","ok","ok"], say:3}
  ];
  [].forEach.call(document.querySelectorAll(".td-ax"), function(sc){
    var slots = sc.querySelectorAll(".td-ax-m"), says = sc.querySelectorAll(".td-ax-s");
    if(!slots.length) return;
    var k = -1;
    setInterval(function(){
      k = (k+1) % STEPS.length;
      var s = STEPS[k];
      for(var i=0;i<slots.length;i++){
        slots[i].classList.remove("ok","no");
        if(s.slots[i]) slots[i].classList.add(s.slots[i]);
      }
      for(var j=0;j<says.length;j++) says[j].classList.toggle("on", j===s.say);
    }, 2000);
  });
})();

/* ---------- Brake reaction: two runs, a fast one and a slow one ---------- */
(function(){
  var RUNS = [1.20, 4.30];
  [].forEach.call(document.querySelectorAll(".td-br"), function(sc){
    var out = sc.querySelector(".td-br-t"), verdict = sc.querySelector(".td-br-v"),
        bars = sc.querySelectorAll(".td-br-b i");
    if(!out) return;
    var run = 0, t = 0, phase = 0;   /* 0 counting, 1 holding, 2 cleared */
    function bandOf(v){ return v < 0.5 ? 0 : v < 1.5 ? 1 : 2; }
    var COL = ["#4ade80", "#f2c21f", "#ff5f74"], WORD = ["FAST", "AVERAGE", "SLOW"];
    setInterval(function(){
      var target = RUNS[run];
      if(phase === 0){
        t += target / 26;
        if(t >= target){ t = target; phase = 1; var hold = 0;
          var b = bandOf(t);
          /* the bars fill to show where this run landed, tallest at the band it hit */
          for(var i=0;i<bars.length;i++){
            bars[i].style.height = (i === b ? 40 : 12) + "px";
            bars[i].style.background = i === b ? COL[b] : "#39414b";
          }
          verdict.textContent = WORD[b];
          verdict.style.background = COL[b];
          verdict.classList.add("on");
          setTimeout(function(){
            verdict.classList.remove("on");
            for(var i=0;i<bars.length;i++){ bars[i].style.height="0px"; bars[i].style.background="#39414b"; }
            t = 0; phase = 0; run = (run+1) % RUNS.length;
            out.textContent = "0.00";
          }, 1900);
        }
        out.textContent = t.toFixed(2);
      }
    }, 60);
  });
})();

/* ---------- Alternative size: too big, then right ---------- */
(function(){
  [].forEach.call(document.querySelectorAll(".td-sz"), function(sc){
    var b = sc.querySelector(".td-sz-b"), vs = sc.querySelector(".td-sz-vs"),
        v = sc.querySelector(".td-sz-v");
    if(!b) return;
    var big = true;
    function paint(){
      b.classList.toggle("big", big);
      vs.classList.toggle("ok", !big);
      v.textContent = big ? "18\" TOO TALL \u2014 SPEEDO READS WRONG"
                          : "18\" MATCHED \u2014 SAME ROLLING DIAMETER";
      v.style.color = big ? "#ff5f74" : "#4ade80";
    }
    paint();
    setInterval(function(){ big = !big; paint(); }, 2600);
  });
})();

/* ---------- Namespace the SVG ids, first thing ----------
   Only the four cards carrying the SUV have ids at all -- the other three are pure
   CSS. url(#id) resolves to the first match in the DOCUMENT, so a second copy of
   one of these silently borrows the first copy's clipPath and renders wrong without
   throwing anything. Same fix as td-guide-cards.js: rename on load. */
(function(){
  var seq = 0;
  function reid(root, tag){
    var map = {};
    [].forEach.call(root.querySelectorAll("[id]"), function(el){
      var was = el.id, now = tag + "-" + was;
      map[was] = now; el.id = now;
    });
    if(!Object.keys(map).length) return;
    [].forEach.call(root.querySelectorAll("*"), function(el){
      ["fill","stroke","clip-path","filter","mask","href","xlink:href"].forEach(function(a){
        var v = el.getAttribute && el.getAttribute(a);
        if(!v) return;
        if(v.indexOf("url(#") === 0){
          var id = v.slice(5, -1);
          if(map[id]) el.setAttribute(a, "url(#" + map[id] + ")");
        } else if(v.charAt(0) === "#" && map[v.slice(1)]){
          el.setAttribute(a, "#" + map[v.slice(1)]);
        }
      });
    });
  }
  [].forEach.call(document.querySelectorAll(".td-lup,.td-vl,.td-tw2,.td-bd"), function(sc){
    reid(sc, "t" + (++seq));
  });
})();

/* ---------- Load rating upgrade: the crate lands, the index has to move ----------
   One rAF clock drives the crate, the squat and the readout together, so the number
   can never disagree with what the picture is doing. */
(function(){
  var DUR = 5200, REST = 51;
  [].forEach.call(document.querySelectorAll(".td-lup"), function(sc){
    var crate = sc.querySelector(".td-lup-crate"), carEl = sc.querySelector(".td-lup-car"),
        tag = sc.querySelector(".td-lup-tag"), ix = sc.querySelector(".td-lup-ix"),
        kg = sc.querySelector(".td-lup-kg"), note = sc.querySelector(".td-lup-note");
    if(!crate) return;
    var t0 = null;
    function frame(ts){
      if(t0 === null) t0 = ts;
      var p = ((ts - t0) % DUR) / DUR, top, state;
      if(p < 0.14){ top = -34; crate.style.opacity = 0; state = 0; }
      else if(p < 0.30){                                    /* falling */
        var a = (p - 0.14) / 0.16;
        top = -34 + (REST + 34) * a * a; crate.style.opacity = 1; state = 0;
      }
      else if(p < 0.44){ top = REST; crate.style.opacity = 1; state = 1; }   /* over */
      else if(p < 0.92){ top = REST; crate.style.opacity = 1; state = 2; }   /* fixed */
      else { top = REST; crate.style.opacity = 1 - (p - 0.92) / 0.08; state = 2; }
      crate.style.top = top + "px";
      carEl.style.transform = "translateY(" + (p > 0.29 && p < 0.95 ? 3 : 0) + "px)";
      if(state === 0){ tag.className = "td-lup-tag";
        ix.textContent = "94"; kg.textContent = "670 kg"; note.textContent = "PER TYRE"; }
      else if(state === 1){ tag.className = "td-lup-tag over";
        ix.textContent = "94"; kg.textContent = "790 kg"; note.textContent = "OVER THE INDEX"; }
      else { tag.className = "td-lup-tag fixed";
        ix.textContent = "100"; kg.textContent = "800 kg"; note.textContent = "PER TYRE"; }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  });
})();

/* ---------- Vehicle load: the platform only reads once the car is on it ---------- */
(function(){
  var DUR = 6000, TOTAL = 1840, PARK = 16;
  var fmt = function(n){ return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ","); };
  [].forEach.call(document.querySelectorAll(".td-vl"), function(sc){
    var carEl = sc.querySelector(".td-vl-car"), plate = sc.querySelector(".td-vl-plate"),
        kg = sc.querySelector(".td-vl-kg"), f = sc.querySelector(".td-vl-f"),
        r = sc.querySelector(".td-vl-r");
    if(!carEl) return;
    var t0 = null;
    function frame(ts){
      if(t0 === null) t0 = ts;
      var p = ((ts - t0) % DUR) / DUR, x, on;
      if(p < 0.30){ var a = p / 0.30; x = -150 + (PARK + 150) * (1 - (1 - a) * (1 - a)); on = 0; }
      else { x = PARK; on = Math.min(1, (p - 0.30) / 0.11); }
      carEl.style.left = x + "px";
      plate.style.transform = "scaleY(" + (p < 0.28 ? 1 : 0.78) + ")";
      kg.textContent = fmt(TOTAL * on);
      if(on >= 1){ f.textContent = fmt(TOTAL * 0.56); r.textContent = fmt(TOTAL * 0.44); }
      else { f.innerHTML = "&mdash;"; r.innerHTML = "&mdash;"; }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  });
})();

/* ---------- Towing load: re-weighed, the three figures move together ---------- */
(function(){
  var SETUPS = [[2100, 1600, 160], [2100, 2000, 200], [2100, 2400, 240]];
  var fmt = function(n){ return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ","); };
  [].forEach.call(document.querySelectorAll(".td-tw2"), function(sc){
    var v = sc.querySelector(".td-tw2-v"), t = sc.querySelector(".td-tw2-t"),
        b = sc.querySelector(".td-tw2-b");
    if(!b) return;
    var k = 0;
    setInterval(function(){
      k = (k + 1) % SETUPS.length;
      v.textContent = fmt(SETUPS[k][0]);
      t.textContent = fmt(SETUPS[k][1]);
      b.textContent = fmt(SETUPS[k][2]);
    }, 1800);
  });
})();

/* ---------- WOF checklist: tick down the list, then stamp it ---------- */
(function(){
  [].forEach.call(document.querySelectorAll(".td-wq"), function(sc){
    var rows = sc.querySelectorAll(".td-wq-r"), stamp = sc.querySelector(".td-wq-stamp");
    if(!rows.length) return;
    var k = rows.length;                    /* markup ships finished; carry on from there */
    setInterval(function(){
      k++;
      if(k === rows.length + 7){             /* hold the stamp, then clear and run again */
        stamp.classList.remove("on");
        for(var i = 0; i < rows.length; i++) rows[i].classList.remove("on");
        k = -1;
      } else if(k >= 0 && k < rows.length){ rows[k].classList.add("on"); }
      else if(k === rows.length){ stamp.classList.add("on"); }
    }, 520);
  });
})();

/* ---------- DOT: type the code, then look up what the code can give ----------
   Both of these are real codes off tyres the shop has physically inspected. The
   date always decodes; the brand only if the plant code is registered; the pattern
   only if the factory's own code is one we have on record. The Bridgestone gives
   all three, the Dunlop gives brand and no pattern. */
(function(){
  /* code, week, year, age chip, is-old, brand, pattern */
  var CODES = [
    ["7GAP P3H 3823", "WEEK 38", "2023", "UNDER 5 YEARS", false,
     "Bridgestone", "Potenza S001"],
    ["V0 146 X816", "WEEK 14", "1986", "OVER 10 YEARS", true,
     "Dunlop", ""]
  ];
  [].forEach.call(document.querySelectorAll(".td-dot"), function(sc){
    var out = sc.querySelector(".td-dot-code"), panel = sc.querySelector(".td-dot-out"),
        wk = sc.querySelector(".td-dot-week"), yr = sc.querySelector(".td-dot-yr"),
        age = sc.querySelector(".td-dot-age"),
        bWrap = sc.querySelector(".td-dot-b"), sWrap = sc.querySelector(".td-dot-s");
    if(!out) return;
    var c = 0, n = CODES[0][0].length, hold = 30;   /* markup ships the Bridgestone */
    setInterval(function(){
      if(hold > 0){
        if(--hold === 0){
          c = (c + 1) % CODES.length; n = 0;
          out.textContent = ""; panel.classList.remove("on");
          bWrap.classList.remove("on"); sWrap.classList.remove("on");
          bWrap.querySelector("b").textContent = "—";
          sWrap.querySelector("b").textContent = "—";
        }
        return;
      }
      n++;
      out.textContent = CODES[c][0].slice(0, n);
      if(n >= CODES[c][0].length){
        var d = CODES[c];
        wk.textContent = d[1]; yr.textContent = d[2];
        age.textContent = d[3];
        age.classList.toggle("old", d[4]);
        yr.style.color = d[4] ? "#ff5f74" : "#e8edf2";
        panel.classList.add("on");
        if(d[5]){ bWrap.querySelector("b").textContent = d[5]; bWrap.classList.add("on"); }
        else    { bWrap.querySelector("b").textContent = "not registered"; }
        if(d[6]){ sWrap.querySelector("b").textContent = d[6]; sWrap.classList.add("on"); }
        else    { sWrap.querySelector("b").textContent = "not encoded"; }
        hold = 30;
      }
    }, 130);
  });
})();

/* ---------- Braking distance: build speed, brake in the zone, stop ---------- */
(function(){
  var DUR = 6200, STOP_M = 42.7;
  [].forEach.call(document.querySelectorAll(".td-bd"), function(sc){
    var carEl = sc.querySelector(".td-bd-car"), kmh = sc.querySelector(".td-bd-kmh"),
        m = sc.querySelector(".td-bd-m"), road = sc.querySelector(".td-bd-road i"),
        dist = sc.querySelector(".td-bd-dist");
    if(!carEl) return;
    var t0 = null;
    function frame(ts){
      if(t0 === null) t0 = ts;
      var W = sc.clientWidth, CW = carEl.offsetWidth || 96, END = W - CW - 6, BRAKE = W * 0.46;
      var p = ((ts - t0) % DUR) / DUR, v, x, d;
      if(p < 0.40){                                     /* building speed */
        var a = p / 0.40;
        v = 100 * a; x = -CW + (BRAKE + CW) * a * a; d = 0;
      } else if(p < 0.74){                              /* on the brakes */
        var b = (p - 0.40) / 0.34, e = 1 - (1 - b) * (1 - b);
        v = 100 * (1 - b); x = BRAKE + (END - BRAKE) * e; d = STOP_M * e;
      } else {                                          /* stopped, holding */
        v = 0; x = END; d = STOP_M;
      }
      carEl.style.left = x + "px";
      kmh.textContent = Math.round(v);
      m.textContent = d.toFixed(1);
      dist.style.opacity = p < 0.40 ? 0.35 : 1;
      if(road) road.style.transform = "translateX(" + (-(ts / 7) % 46) + "px)";
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  });
})();

/* ---------- Daily report: town, then the readings, then the ring ----------
   Three towns in rotation. Each carries its own readings, its own score and its
   own ring colour, so the card shows the tool covers more than one place -- and
   the row LABELS move with the town, because wind is Wellington's story the way
   rain is Tauranga's. */
(function(){
  var C = 2 * Math.PI * 17;
  var TOWNS = [
    {name: "Auckland",   sub: "Tāmaki Makaurau",
     rows: [["Rain", "2 mm"], ["Surface", "Damp"], ["Stopping", "+19%"]], score: 94, band: ""},
    {name: "Tauranga",   sub: "Bay of Plenty",
     rows: [["Rain", "12 mm"], ["Surface", "Wet"], ["Stopping", "+38%"]], score: 87, band: ""},
    {name: "Wellington", sub: "Te Whanganui-a-Tara",
     rows: [["Wind", "74 km/h"], ["Surface", "Wet"], ["Stopping", "+41%"]], score: 68, band: "low"}
  ];
  [].forEach.call(document.querySelectorAll(".td-dsr"), function(sc){
    var town = sc.querySelector(".td-dsr-town"), name = sc.querySelector(".td-dsr-name"),
        sub = sc.querySelector(".td-dsr-sub"), rows = sc.querySelectorAll(".td-dsr-row"),
        arc = sc.querySelector(".td-dsr-arc"), score = sc.querySelector(".td-dsr-score");
    if(!town) return;
    var up = null, k = 1, t = rows.length + 4;  /* markup ships Tauranga finished */
    function clear(){
      if(up){ clearInterval(up); up = null; }
      town.classList.remove("on"); name.textContent = "…";
      for(var i = 0; i < rows.length; i++) rows[i].classList.remove("on");
      arc.style.strokeDashoffset = C; score.textContent = "0";
    }
    setInterval(function(){
      t++;
      var T = TOWNS[k];
      if(t === rows.length + 10){ clear(); k = (k + 1) % TOWNS.length; t = -1; }
      else if(t === 1){
        town.classList.add("on");
        name.textContent = T.name; sub.textContent = T.sub;
      }
      else if(t > 1 && t <= rows.length + 1){
        var r = rows[t - 2], d = T.rows[t - 2];
        r.querySelector("em").textContent = d[0];
        r.querySelector("b").textContent = d[1];
        r.classList.add("on");
      }
      else if(t === rows.length + 2){
        arc.className.baseVal = "td-dsr-arc" + (T.band ? " " + T.band : "");
        arc.style.strokeDashoffset = C * (1 - T.score / 100);
        var n = 0;
        up = setInterval(function(){
          n += 3; if(n >= T.score){ n = T.score; clearInterval(up); up = null; }
          score.textContent = n;
        }, 34);
      }
    }, 460);
  });
})();

/* ---------- Scanner: the strip runs, the reading names what is under the line ----------
   One rAF clock again, so the label can never name a marking that is not actually
   under the line. */
(function(){
  var MEANING = ["TYRE SIZE","LOAD 670KG · SPEED 270KM/H","MADE WEEK 48, 2023","WEAR RATING","MUD & SNOW RATED"], GAP = 120, HOLD = 1500, SLIDE = 700;
  [].forEach.call(document.querySelectorAll(".td-scan"), function(sc){
    var strip = sc.querySelector(".td-scan-strip"), what = sc.querySelector(".td-scan-what"),
        n = sc.querySelector(".td-scan-n");
    if(!strip) return;
    var STEP = HOLD + SLIDE, DUR = STEP * MEANING.length, t0 = null;
    function frame(ts){
      if(t0 === null) t0 = ts;
      var e = (ts - t0) % DUR, i = Math.floor(e / STEP), into = e - i * STEP;
      var f = into <= HOLD ? 0 : (into - HOLD) / SLIDE;
      f = f * f * (3 - 2 * f);                    /* ease, so it settles rather than snaps */
      strip.style.transform = "translateX(" + (40 - GAP * (i + f)) + "px)";
      what.textContent = MEANING[i];
      n.textContent = (i + 1) + " / " + MEANING.length;
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  });
})();

/* ---------- Life cost: both lanes cover the same distance ---------- */
(function(){
  var DUR = 7000, TOTAL = 65000, LIFE = 30000, SET = 120, PREM = 220;
  [].forEach.call(document.querySelectorAll(".td-cost"), function(sc){
    var a = sc.querySelector(".td-cost-a u"), b = sc.querySelector(".td-cost-b u"),
        at = sc.querySelector(".td-cost-at"), bt = sc.querySelector(".td-cost-bt"),
        km = sc.querySelector(".td-cost-km");
    if(!a) return;
    var t0 = null;
    function frame(ts){
      if(t0 === null) t0 = ts;
      var p = ((ts - t0) % DUR) / DUR;
      var run = p < 0.82 ? Math.min(1, p / 0.82) : 1;   /* then hold on the answer */
      var d = TOTAL * run;
      a.style.width = b.style.width = (run * 100) + "%";
      at.textContent = "$" + (SET * Math.max(1, Math.ceil(d / LIFE)));
      bt.textContent = "$" + PREM;
      km.textContent = Math.round(d).toLocaleString() + " KM";
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  });
})();

/* ---------- Kicker: type the size, then the matches arrive ---------- */
(function(){
  var Q = "205/55R16";
  [].forEach.call(document.querySelectorAll(".td-kick"), function(sc){
    var q = sc.querySelector(".td-kick-q"), rows = sc.querySelectorAll(".td-kick-r");
    if(!q) return;
    var n = Q.length, k = rows.length, hold = 26;   /* markup ships finished */
    setInterval(function(){
      if(hold > 0){
        if(--hold === 0){
          n = 0; k = 0; q.textContent = "";
          for(var i = 0; i < rows.length; i++) rows[i].classList.remove("on");
        }
        return;
      }
      if(n < Q.length){ q.textContent = Q.slice(0, ++n); return; }
      if(k < rows.length){ rows[k++].classList.add("on"); if(k === rows.length) hold = 26; }
    }, 130);
  });
})();

/* ---------- Size calculator: the numbers, and what they add up to ---------- */
(function(){
  var SIZES = [[225, 50, 17], [205, 55, 16], [265, 65, 17]], BIG = 0;
  SIZES.forEach(function(s){ var od = s[2] * 25.4 + 2 * s[0] * s[1] / 100; if(od > BIG) BIG = od; });
  [].forEach.call(document.querySelectorAll(".td-sc"), function(sc){
    var w = sc.querySelector(".td-sc-w"), p = sc.querySelector(".td-sc-p"),
        r = sc.querySelector(".td-sc-r"), odt = sc.querySelector(".td-sc-od-t"),
        c = sc.querySelector(".td-sc-c"), od = sc.querySelector(".td-sc-od"),
        rim = sc.querySelector(".td-sc-rim");
    if(!od) return;
    var k = 0;
    function paint(){
      var s = SIZES[k], mm = s[2] * 25.4 + 2 * s[0] * s[1] / 100;
      w.textContent = s[0]; p.textContent = s[1]; r.textContent = s[2];
      odt.textContent = Math.round(mm) + " mm";
      c.textContent = (Math.PI * mm / 1000).toFixed(2) + " m";
      /* 46 units is the biggest size in the cycle, so they are to scale against
         each other rather than each redrawn to fill the box */
      od.setAttribute("r", (46 * mm / BIG).toFixed(2));
      rim.setAttribute("r", (46 * (s[2] * 25.4) / BIG).toFixed(2));
    }
    setInterval(function(){ k = (k + 1) % SIZES.length; paint(); }, 2600);
  });
})();

/* ---------- Namespace the SVG ids ----------
   Only the pressure card carries any (they come with the SUV). url(#id) resolves
   to the first match in the DOCUMENT, so a second copy of the card would silently
   borrow the first one's clipPath and render wrong without erroring. */
(function(){
  var seq = 0;
  [].forEach.call(document.querySelectorAll(".td-pr3"), function(sc){
    var tag = "p" + (++seq), map = {};
    [].forEach.call(sc.querySelectorAll("[id]"), function(el){
      map[el.id] = tag + "-" + el.id; el.id = map[el.id];
    });
    if(!Object.keys(map).length) return;
    [].forEach.call(sc.querySelectorAll("*"), function(el){
      ["fill","stroke","clip-path","filter","mask","href","xlink:href"].forEach(function(a){
        var v = el.getAttribute && el.getAttribute(a);
        if(!v) return;
        if(v.indexOf("url(#") === 0){ var id = v.slice(5, -1);
          if(map[id]) el.setAttribute(a, "url(#" + map[id] + ")"); }
        else if(v.charAt(0) === "#" && map[v.slice(1)]) el.setAttribute(a, "#" + map[v.slice(1)]);
      });
    });
  });
})();

/* ---------- Scanner: one reading at a time crosses to the phone ---------- */
(function(){
  var M = [["225/50R17","Size","TYRE SIZE"],["94W","Load/Spd","LOAD 670KG · SPEED 270KM/H"],["DOT HW9L 4823","DOT","MADE WEEK 48, 2023"],["E4 021234","E-mark","ECE APPROVED · NETHERLANDS"],["CCC","CCC","CHINA COMPULSORY CERT"],["TREADWEAR 320","UTQG","UTQG WEAR RATING"],["M+S ❄","M+S","MUD & SNOW · 3PMSF"]], HOLD = 500, TRIP = 1250;
  [].forEach.call(document.querySelectorAll(".td-sc3"), function(sc){
    var flow = sc.querySelector(".td-sc3-flow"), pkt = sc.querySelector(".td-sc3-pkt"),
        what = sc.querySelector(".td-sc3-what"), n = sc.querySelector(".td-sc3-n"),
        rows = sc.querySelectorAll(".td-sc3-row");
    if(!pkt) return;
    var STEP = HOLD + TRIP, DUR = STEP * M.length, t0 = null;
    function frame(ts){
      if(t0 === null) t0 = ts;
      var e = (ts - t0) % DUR, i = Math.floor(e / STEP), into = e - i * STEP;
      var W = flow.clientWidth;
      if(into < HOLD){                              /* sitting at the tyre */
        pkt.style.left = W + "px"; pkt.style.opacity = into / HOLD;
      } else {                                      /* crossing to the phone */
        var f = (into - HOLD) / TRIP;
        pkt.style.left = (W * (1 - f)) + "px";
        pkt.style.opacity = f > 0.86 ? (1 - f) / 0.14 : 1;
      }
      pkt.textContent = M[i][0];
      what.textContent = M[i][2];
      n.textContent = (i + 1) + " / " + M.length;
      /* a row lights the moment its reading lands, and stays lit for the lap */
      for(var r = 0; r < rows.length; r++){
        var landed = r < i || (r === i && into > HOLD + TRIP * 0.86);
        rows[r].classList.toggle("on", landed);
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  });
})();

/* ---------- Size calculator: four sizes, one baseline ---------- */
(function(){
  var SETS = [[[175, 65, 14], [205, 55, 16], [235, 65, 17], [285, 75, 16]], [[205, 55, 16], [215, 50, 17], [225, 45, 17], [245, 45, 18]]];
  function od(s){ return s[2] * 25.4 + 2 * s[0] * s[1] / 100; }
  [].forEach.call(document.querySelectorAll(".td-s4"), function(sc){
    var cols = sc.querySelectorAll(".td-s4-c"), k = 0;
    function paint(){
      var set = SETS[k], base = od(set[0]), max = 0;
      set.forEach(function(s){ max = Math.max(max, od(s)); });
      for(var i = 0; i < cols.length; i++){
        var s = set[i], d = od(s), pc = (d - base) / base * 100;
        var t = cols[i].querySelector(".td-s4-t");
        var cap = Math.max(24, cols[i].clientWidth - 4);   /* never wider than its column */
        t.style.width = t.style.height = (cap * d / max).toFixed(1) + "px";
        cols[i].querySelector("b").textContent = s[0] + "/" + s[1] + "R" + s[2];
        var lab = cols[i].querySelector("i");
        lab.textContent = i === 0 ? "BASE" : (pc >= 0 ? "+" : "") + pc.toFixed(1) + "%";
        lab.className = i === 0 ? "ok"
          : (Math.abs(pc) < 1.5 ? "ok" : (Math.abs(pc) < 3 ? "warn" : "bad"));
        /* replay the grow so a new set arrives the way the first one did */
        t.style.animation = "none"; void t.offsetWidth;
        t.style.animation = "";
      }
    }
    setInterval(function(){ k = (k + 1) % SETS.length; paint(); }, 4200);
  });
})();

/* ---------- Kicker: type the size, then the rows arrive ---------- */
(function(){
  var Q = "205/55R16";
  [].forEach.call(document.querySelectorAll(".td-k3"), function(sc){
    var q = sc.querySelector(".td-k3-q"), rows = sc.querySelectorAll(".td-k3-r");
    if(!q) return;
    var n = Q.length, k = rows.length, hold = 28;     /* markup ships finished */
    setInterval(function(){
      if(hold > 0){
        if(--hold === 0){ n = 0; k = 0; q.textContent = "";
          for(var i = 0; i < rows.length; i++) rows[i].classList.remove("on"); }
        return;
      }
      if(n < Q.length){ q.textContent = Q.slice(0, ++n); return; }
      if(k < rows.length){ rows[k++].classList.add("on"); if(k === rows.length) hold = 28; }
    }, 120);
  });
})();

/* ---------- Pressure: weight AND size both move ---------- */
(function(){
  var CASES = [["HATCH", "1,240 kg", "195/65R15", 30, ""],
               ["SUV",   "1,840 kg", "225/50R17", 36, "hi"],
               ["UTE",   "2,240 kg", "265/65R17", 42, "top"]];
  [].forEach.call(document.querySelectorAll(".td-pr3"), function(sc){
    var kg = sc.querySelector(".td-pr3-kg"), sz = sc.querySelector(".td-pr3-sz"),
        psi = sc.querySelector(".td-pr3-psi"), state = sc.querySelector(".td-pr3-state"),
        plate = sc.querySelector(".td-pr3-plate"), carEl = sc.querySelector(".td-pr3-car");
    if(!psi) return;
    var k = 1;                                       /* markup ships the SUV case */
    setInterval(function(){
      k = (k + 1) % CASES.length;
      var c = CASES[k];
      state.textContent = c[0];
      state.className = "td-pr3-state" + (c[4] ? " " + c[4] : "");
      kg.textContent = c[1]; sz.textContent = c[2]; psi.textContent = c[3];
      psi.style.color = k === 2 ? "#ff5f74" : "#fff";
      plate.style.transform = "scaleY(" + (0.9 - k * 0.08).toFixed(2) + ")";
      carEl.style.transform = "translateY(" + k + "px)";
    }, 2400);
  });
})();

/* ---------- Following distance: the metres follow the speed ---------- */
(function(){
  var SPEEDS = [50, 80, 100], MAXM = 100 / 3.6 * 4;
  [].forEach.call(document.querySelectorAll(".td-fd"), function(sc){
    var kmh = sc.querySelector(".td-fd-kmh"), d = sc.querySelector(".td-fd-d"),
        w = sc.querySelector(".td-fd-w"), du = sc.querySelector(".td-fd-dry u"),
        wu = sc.querySelector(".td-fd-wet u");
    if(!kmh) return;
    var k = 1;
    setInterval(function(){
      k = (k + 1) % SPEEDS.length;
      var v = SPEEDS[k];
      kmh.textContent = v;
      d.textContent = Math.round(v / 3.6 * 2) + " m";
      w.textContent = Math.round(v / 3.6 * 4) + " m";
      du.style.width = (v / 3.6 * 2 / MAXM * 100) + "%";
      wu.style.width = (v / 3.6 * 4 / MAXM * 100) + "%";
    }, 2200);
  });
})();
